<ng-container *transloco="let t; prefix: 'orders.customerConfiguration'">
  @if (customer(); as company) {
    <mat-card class="customer-summary" appearance="outlined">
      <mat-card-content class="customer-summary-content">
        <span class="customer-summary-name headline-small-emphasized">{{ company.ragioneSociale }}</span>
        <div class="customer-summary-field">
          <span class="body-large-emphasized">{{ t('taxCode') }}</span>
          <span class="body-large">{{ company.codiceFiscale || '—' }}</span>
        </div>
        <div class="customer-summary-field">
          <span class="body-large-emphasized">{{ t('vatNumber') }}</span>
          <span class="body-large">{{ company.partitaIva || '—' }}</span>
        </div>
      </mat-card-content>
    </mat-card>

    <div class="gdpr-content">
      <div class="gdpr-heading">
        <div class="gdpr-title">
          <a matIconButton [routerLink]="['/new-order-proposal/configure-customer/order-notes']" [queryParams]="{ id: proposalId }" [attr.aria-label]="t('backToOrderNotes')"><i class="fa-regular fa-arrow-left" aria-hidden="true"></i></a>
          <span class="title-medium-emphasized">{{ t('gdprTitle') }}</span>
        </div>
        <!-- TODO: Collegare il template ufficiale GDPR quando sarà fornito il file o l'endpoint. -->
        <button matButton type="button" disabled>
          <span class="download-template-label"><i class="fa-regular fa-download" aria-hidden="true"></i><span>{{ t('downloadTemplate') }}</span></span>
        </button>
      </div>

      <div class="gdpr-upload">
        <span class="body-large-emphasized">{{ t('uploadSignedGdpr') }} *</span>
        <input #fileInput type="file" accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png" hidden (change)="chooseFile($event)">
        <div class="gdpr-dropzone" [class.gdpr-dropzone--dragging]="dragging()" (dragover)="dragOver($event)" (dragleave)="dragging.set(false)" (drop)="dropFile($event)">
          <i class="fa-regular fa-arrow-up-from-bracket upload-icon" aria-hidden="true"></i>
          <span class="body-large">{{ t('attachDocument') }}</span>
          <span class="body-medium">{{ t('bankingFileHint') }}</span>
          <button matButton type="button" (click)="fileInput.click()">{{ t('browseFiles') }}</button>
        </div>
        @if (configuration.gdprDocument(); as document) {
          <div class="gdpr-file" role="status">
            <span class="body-medium">{{ document.name }}</span>
            <button matIconButton type="button" [attr.aria-label]="t('removeDocument')" (click)="removeFile()"><i class="fa-regular fa-xmark" aria-hidden="true"></i></button>
          </div>
        }
        @if (fileError(); as error) {
          <span class="gdpr-file-error body-medium" role="alert">{{ t(error) }}</span>
        }
      </div>

      <div class="gdpr-info" role="status">
        <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
        <div class="gdpr-info-text">
          <span class="body-medium-emphasized">{{ t('gdprInfoTitle') }}</span>
          <span class="body-medium">{{ t('gdprInfoDescription') }}</span>
        </div>
      </div>

      <div class="gdpr-actions">
        <button matButton="outlined" type="button" [disabled]="!configuration.destinationForConfiguration()" (click)="skipForNow()">{{ t('skipForNow') }}</button>
        <button matButton="filled" type="button" [disabled]="!canContinue()" (click)="continue()">{{ t('continue') }}</button>
      </div>
    </div>
  } @else {
    <div class="gdpr-state">
      <span class="body-large">{{ t('missingCustomer') }}</span>
      <a matButton="outlined" [routerLink]="['/new-order-proposal/new-customer']" [queryParams]="{ id: proposalId }">{{ t('backToSearch') }}</a>
    </div>
  }
</ng-container>
